export enum EmailMarketingProviderType {
    None = "None",
    Maileroo = "Maileroo",
    Mailchimp = "Mailchimp",
    CampaignMonitor = "CampaignMonitor"
  }
//   export const EmailMarketingProviderList = [
//   EmailMarketingProviderType.None,
//   EmailMarketingProviderType.Maileroo,
//   EmailMarketingProviderType.Mailchimp,
//   EmailMarketingProviderType.CampaignMonitor
// ];